import { useState } from "react";
import { AdaptedButton } from "../../components/adaptedButton";
import { StyleSheet, View } from "react-native";


export function Page9({ handleClick }) {
  const [selectedValue, setSelectedValue] = useState('');
  const handleButtonClick = (name, value) => {
    setSelectedValue(value)
    handleClick(name, value);
  };
  return (
<View style={styles.center}>
  <View style={styles.fix}>
    <AdaptedButton
      handleClick={handleButtonClick}
      field={'acne_concerns'}
      fieldValue={'Not at all'}
      selected={selectedValue === 'Not at all'}
    />
  </View>
  <View style={styles.fix}>
    <AdaptedButton
      handleClick={handleButtonClick}
      field={'acne_concerns'}
      fieldValue={'Some concern'}
      selected={selectedValue === 'Some concern'}
    />
  </View>
  <View style={styles.fix}>
    <AdaptedButton
      handleClick={handleButtonClick}
      field={'acne_concerns'}
      fieldValue={'Very concerned'}
      selected={selectedValue === 'Very concerned'}
    />
  </View>
</View>

  );
}

const styles = StyleSheet.create({
  fix: {
      width: 300,
      margin: 2,
    },
  center:{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
  }
});